module.exports = __webpack_public_path__ + "img/rztg.226a0146.png";